module.exports = __webpack_public_path__ + "media/components/guide-page/static/icon-wetsuit--rashvest-8be4ac328747cea8622ec647b7d0d34d.svg";